import { Home } from 'ui/screens/home'

function App() {
  return (
    <Home />
  )
}

export { App }
